export default __webpack_public_path__ + "static/media/controlRM.38cae434.png";